// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isAppsTransformationTemplatesDatatableResult = objectOf({
  id: string,
  c_id: maybe(string),
  ag_id: maybe(string),
  name: string,
  description: string,
  code: string,
  endpoint: string,
  source: string,
});
